import React from 'react';
import NewsList from '../../components/features/NewsList';

const NewsPage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-extrabold text-gray-900 mb-8">最近新闻</h1>
      <NewsList />
    </div>
  );
};

export default NewsPage;
